module.exports = "<backupplans-page></backupplans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/backups.html
// module id = 1672
// module chunks = 0